import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import ModuleBoundary from "../components/ModuleBoundary";
import { hydrateResponsiveTables } from "../utils/responsiveTables";
import useMobileSidebar from "../hooks/useMobileSidebar";
import { NotificationProvider } from "../context/NotificationContext";
import RequiredDepartmentMessageInbox from "../pages/team-it/RequiredDepartmentMessageInbox";
import "../styles/mobileWorkspace.css";
import { Outlet, useLocation } from "react-router-dom";


export const hydrateWorkspaceTables = () => hydrateResponsiveTables(document.querySelector(".workspace-content"));

const WorkspaceLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    useMobileSidebar(sidebarOpen, setSidebarOpen);

    useEffect(() => {
        setSidebarOpen(false);
    }, [location.pathname]);


    useEffect(() => {
        hydrateWorkspaceTables();

        let frameId = null;
        const scheduleHydration = () => {
            if (frameId !== null) return;
            frameId = window.requestAnimationFrame(() => {
                frameId = null;
                hydrateWorkspaceTables();
            });
        };
        const timeoutId = window.setTimeout(scheduleHydration, 180);
        const workspace = document.querySelector(".workspace-content");
        const observer = new MutationObserver(scheduleHydration);

        if (workspace) {
            observer.observe(workspace, { childList: true, subtree: true, characterData: true });
        }
        window.addEventListener("resize", scheduleHydration);

        return () => {
            window.clearTimeout(timeoutId);
            if (frameId !== null) window.cancelAnimationFrame(frameId);
            window.removeEventListener("resize", scheduleHydration);
            observer.disconnect();
        };
    }, [location.pathname]);

    useEffect(() => {
        document.body.classList.toggle("soma-sidebar-open", sidebarOpen);
        return () => document.body.classList.remove("soma-sidebar-open");
    }, [sidebarOpen]);

    return (
        <NotificationProvider><div className={`layout-wrapper layout-content-navbar workspace-shell soma-mco-shell ${sidebarOpen ? "sidebar-mobile-open" : ""}`}>
            <div className="layout-container">
                <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
                <main className="layout-page workspace-main">
                    <Navbar sidebarOpen={sidebarOpen} onToggleSidebar={() => setSidebarOpen((current) => !current)} />
                    <div className="content-wrapper workspace-content">
                        <ModuleBoundary><Outlet /></ModuleBoundary>
                    </div>
                </main>
            </div>
            <button
                className="sidebar-mobile-backdrop"
                type="button"
                aria-label="Fermer le menu"
                tabIndex={-1}
                aria-hidden="true"
                onClick={() => setSidebarOpen(false)}
            />
        </div><RequiredDepartmentMessageInbox /></NotificationProvider>
    );
};

export default WorkspaceLayout;
